import datefns from 'date-fns';

/**
 * @typedef {Object} RangePreset
 * @property {string} label
 * @property {number} start timestamp
 * @property {number} end timestamp
 */

/** @type {RangePreset[]} */
export default [
  {
    label: 'Today',
    start: datefns.startOfDay(Date.now()).getTime(),
    end: datefns.endOfDay(Date.now()).getTime()
  },
  {
    label: 'Yesterday',
    start: datefns.startOfDay(datefns.subDays(Date.now(), 1)).getTime(),
    end: datefns.endOfDay(datefns.subDays(Date.now(), 1)).getTime()
  },
  {
    label: 'Last 7 Days',
    start: datefns.startOfDay(datefns.subDays(Date.now(), 6)).getTime(),
    end: datefns.endOfDay(Date.now()).getTime()
  },
  {
    label: 'Last 30 Days',
    start: datefns.startOfDay(datefns.subDays(Date.now(), 29)).getTime(),
    end: datefns.endOfDay(Date.now()).getTime()
  },
  {
    label: 'This Month',
    start: datefns.startOfDay(datefns.startOfMonth(Date.now())).getTime(),
    end: datefns.endOfDay(Date.now()).getTime()
  },
  {
    label: 'Last Month',
    start: datefns.startOfDay(datefns.startOfMonth(datefns.subMonths(Date.now(), 1))).getTime(),
    end: datefns.endOfDay(datefns.endOfMonth(datefns.subMonths(Date.now(), 1))).getTime()
  }
];
